import { render, staticRenderFns } from "./BankUiIcon.vue?vue&type=template&id=5cae0efe&scoped=true"
import script from "./BankUiIcon.vue?vue&type=script&lang=js"
export * from "./BankUiIcon.vue?vue&type=script&lang=js"
import style0 from "./BankUiIcon.vue?vue&type=style&index=0&id=5cae0efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cae0efe",
  null
  
)

export default component.exports